import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { statsData } from '../../data';
import { statsDataArabic } from '../../data/indexArabic';
import { useAuth } from '../../store/auth';

const StatsSection = () => {
  const { isArabic } = useAuth();
  const data = isArabic ? statsData : statsDataArabic;
  const [counters, setCounters] = useState({});

  // Counter animation effect
  useEffect(() => {
    if (data?.stats) {
      const animateCounters = () => {
        data.stats.forEach((stat, index) => {
          let currentValue = 0;
          const targetValue = parseInt(stat.value);
          const increment = targetValue / 100;
          
          const timer = setInterval(() => {
            currentValue += increment;
            if (currentValue >= targetValue) {
              currentValue = targetValue;
              clearInterval(timer);
            }
            
            setCounters(prev => ({
              ...prev,
              [index]: Math.floor(currentValue)
            }));
          }, 20);
        });
      };

      // Add scroll listener to trigger animation when section is visible
      const handleScroll = () => {
        const section = document.getElementById('stats-section');
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            animateCounters();
            window.removeEventListener('scroll', handleScroll);
          }
        }
      };

      window.addEventListener('scroll', handleScroll);
      // Also trigger on mount in case section is already visible
      handleScroll();

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [data]);

  return (
    <React.Fragment>
      {data && (
        <div id="stats-section">
          <Container>
            <Row className="justify-content-center">
              <Col className="col-12 text-center">
                <div className="section-title mb-4 pb-2">
                  <span className="badge rounded-pill bg-soft-primary">{data?.badgeText}</span>
                  <h4 className="title mt-3 mb-4">
                    {data?.titles?.map((ele, index) => (
                      <span key={index} className={ele.highlight ? 'text-primary' : ''}>
                        {ele.breakPoint && <br />}
                        {ele.title}
                      </span>
                    ))}
                  </h4>
                  <p className="text-muted para-desc mb-0 mx-auto">
                    {data?.description?.map((ele, index) => (
                      <span className={ele.highlight ? 'text-primary fw-bold' : ''} key={index}>
                        {ele.content}
                      </span>
                    ))}
                  </p>
                </div>
              </Col>
            </Row>

            <Row>
              {data?.stats?.map((stat, key) => (
                <Col key={key} lg={3} md={6} className="mt-4 pt-2">
                  <Card className="features feature-primary text-center border-0 rounded-3 shadow-sm p-4 h-100">
                    <div className="image position-relative d-inline-block mb-4">
                      <div className="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto" style={{ width: '80px', height: '80px' }}>
                        <FeatherIcon icon={stat.icon} className="text-primary" size={32} />
                      </div>
                    </div>
                    <CardBody className="p-0">
                      <div className="counter-value mb-2">
                        <h2 className="text-primary mb-0 fw-bold">
                          {counters[key] || 0}
                          {stat.suffix && <span className="text-primary">{stat.suffix}</span>}
                        </h2>
                      </div>
                      <h5 className="title mb-2">{stat.title}</h5>
                      <p className="text-muted mb-0">{stat.description}</p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Additional Achievement Section */}
            {data?.achievements && (
              <Row className="mt-5">
                <Col className="col-12">
                  <div className="text-center">
                    <h5 className="text-muted mb-4">{data.achievements.title}</h5>
                    <Row className="justify-content-center">
                      {data.achievements.items?.map((achievement, key) => (
                        <Col key={key} lg={2} md={3} sm={4} className="col-6 mb-3">
                          <div className="text-center p-3">
                            <FeatherIcon icon={achievement.icon} className="text-primary mb-2" size={24} />
                            <h6 className="mb-0 small">{achievement.title}</h6>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      )}
    </React.Fragment>
  );
};

export default StatsSection;
